import { render, staticRenderFns } from "./AdminBackgroundTasks.vue?vue&type=template&id=79fbfe0f&scoped=true&"
import script from "./AdminBackgroundTasks.vue?vue&type=script&lang=js&"
export * from "./AdminBackgroundTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fbfe0f",
  null
  
)

export default component.exports